import { CircularProgress, Divider, Typography } from '@mui/material';
import { computed, makeObservable, observable, runInAction } from 'mobx';
import { inject, observer } from 'mobx-react';
import ReactComponent from '../ReactComponent';
import PainelProcessoOperacoesEmLote from './PainelProcessoOperacoesEmLote';
import PainelProcessoOperacoesEmLotePartes from './PainelProcessoOperacoesEmLotePartes';

class PainelProcessosOperacoesEmLotePartes extends ReactComponent {
    scrollRoot;

    constructor(props) {
        super(props);

        makeObservable(this, {
            scrollRoot: observable,
            partesSelecionaveis: computed
        });
    }

    componentDidMount() {
        runInAction(() => (this.scrollRoot = document.getElementById('scrollListaProcessosOperacoesEmLotePartes')));
    }

    get partesSelecionaveis() {
        return this.observableProps.partesSelecionaveis;
    }

    partes(registro) {
        return this.partesSelecionaveis.get(registro.processo.numeroCompleto);
    }

    render() {
        return this.sessaoStore.carregandoProcessos ||
            this.store.carregandoProcessos ||
            !this.observableProps.processos ? (
            <div style={{ display: 'flex', flexGrow: 1, margin: '20px' }}>
                <CircularProgress
                    style={{ margin: '20px' }}
                    disableShrink={true}
                />
                <Typography
                    variant="h6"
                    style={{ margin: '25px 10px' }}
                >
                    Carregando processos...
                </Typography>
            </div>
        ) : (
            this.renderListaProcessos()
        );
    }

    renderListaProcessos() {
        return this.observableProps.processos.length > 0 ? (
            <div
                id={'scrollListaProcessosOperacoesEmLotePartes'}
                style={{ margin: '0px 24px', height: 'calc(100% - 146px)', overflowY: 'auto' }}
            >
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    {this.observableProps.processos.map((processo) => (
                        <div key={this.nextKey}>
                            <PainelProcessoOperacoesEmLotePartes
                                registro={processo}
                                partes={this.partes(processo)}
                                scrollRoot={this.scrollRoot}
                                {...this.observableProps}
                            />
                        </div>
                    ))}
                    <Divider style={{ backgroundColor: 'rgba(0, 0, 0, 0.4)' }} />
                </div>
            </div>
        ) : (
            <Typography
                variant="subtitle1"
                style={{ display: 'flex', flexGrow: '1', margin: '20px' }}
            >
                {this.observableProps.mensagemLoteSemProcessos}
            </Typography>
        );
    }
}

export default inject('stores')(observer(PainelProcessosOperacoesEmLotePartes));
